import PropTypes from "prop-types";
import React from "react";

const Edit = ({ className}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className=""
    >
      <path
        d="M17.3703 10.1704L18.7103 8.75041C20.1303 7.25041 20.7703 5.54042 18.5603 3.45042C16.3503 1.37042 14.6803 2.10041 13.2603 3.60041L5.05034 12.2904C4.74034 12.6204 4.44034 13.2704 4.38034 13.7204L4.01034 16.9604C3.88034 18.1304 4.72034 18.9304 5.88034 18.7304L9.10034 18.1804C9.55034 18.1004 10.1803 17.7704 10.4903 17.4304L14.4403 13.2504"
        stroke="#475467"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8896 5.0498C12.3196 7.8098 14.5596 9.9198 17.3396 10.1998"
        stroke="#475467"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 22H14"
        stroke="#475467"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 22H21"
        stroke="#475467"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Edit.propTypes = {
  className: PropTypes.node.isRequired,
}

export default Edit;
